import styled, { css } from 'styled-components';
import { zIndex } from '../global/globals';
import media from '../base/media';
import { fadeInAndUp, fadeDownAndOut } from '../base/keyframes/fades';

export const Wrapper = styled.div`
	position: fixed;
	bottom: 0; left: 0;
	width: 100%;
	padding: 3rem;
	background-color: #fff;
	box-shadow: 0 -4px 23px rgba(0,0,0,.05);
	z-index: ${zIndex.cookiesDisclaimer};
	opacity: 0;
	transform: translate3d(0, 0, 0);
	animation: ${fadeInAndUp} 450ms ease 450ms forwards;

	${({ fadeOut }) => fadeOut && css`
		opacity: 1;
		transform: translate3d(0, 0, 0);
		animation: ${fadeDownAndOut} 250ms ease forwards;
	`}

	${media.tablet`
		max-width: 54rem;
	`}
`;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	margin-top: 2rem;
`;
